export const ATTRIBUTION_FIELD_NAMES = [
  "gclid",
  "utm_source",
  "utm_campaign",
  "utm_term",
  "utm_medium",
  "utm_content",
  "referrer",
  "landing_page",
];

const STORAGE_KEY = "bcs_lead_attribution";

const emptyAttribution = () =>
  ATTRIBUTION_FIELD_NAMES.reduce((fields, name) => {
    fields[name] = "";
    return fields;
  }, {});

let memoryAttribution = null;

const normaliseAttribution = (value) => {
  const attribution = emptyAttribution();

  if (!value || typeof value !== "object") {
    return attribution;
  }

  ATTRIBUTION_FIELD_NAMES.forEach((name) => {
    if (typeof value[name] === "string") {
      attribution[name] = value[name];
    }
  });

  return attribution;
};

const readStoredAttribution = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    return stored ? normaliseAttribution(JSON.parse(stored)) : null;
  } catch (error) {
    return memoryAttribution;
  }
};

const storeAttribution = (attribution) => {
  memoryAttribution = attribution;

  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch (error) {
    // Some privacy modes disable Web Storage. The in-memory fallback still
    // keeps attribution available while Gatsby is running on the page.
  }
};

/**
 * Capture first-touch lead attribution for this browser tab. This deliberately
 * does not depend on GA/GTM or analytics consent, so a form can carry its own
 * source data when analytics storage is denied.
 */
export const captureAttribution = () => {
  if (typeof window === "undefined") {
    return emptyAttribution();
  }

  const stored = readStoredAttribution();
  if (stored) {
    memoryAttribution = stored;
    return stored;
  }

  const params = new URLSearchParams(window.location.search);
  const attribution = {
    gclid: params.get("gclid") || "",
    utm_source: params.get("utm_source") || "",
    utm_campaign: params.get("utm_campaign") || "",
    utm_term: params.get("utm_term") || "",
    utm_medium: params.get("utm_medium") || "",
    utm_content: params.get("utm_content") || "",
    referrer: typeof document !== "undefined" ? document.referrer || "" : "",
    landing_page: window.location.href,
  };

  storeAttribution(attribution);
  return attribution;
};

export const getAttributionData = () => {
  if (typeof window === "undefined") {
    return emptyAttribution();
  }

  return readStoredAttribution() || memoryAttribution || captureAttribution();
};
